import { render, staticRenderFns } from "./enquiryService.vue?vue&type=template&id=dbb15b90&scoped=true"
import script from "./enquiryService.vue?vue&type=script&lang=js"
export * from "./enquiryService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb15b90",
  null
  
)

export default component.exports